/*
This module was wrongly defined previously &
imported in almost all the files in frontend.

the bug was along these lines:

```
import axios from axios

export default axios.create({ ... headers:{..} })

axios.interceptor.use(()=>{})
```
while import default import syntax was used
but the expoted axios instance did not have interceptors set,
instead it was set on original axios instance which was never used.
*/
import Vue from "vue";
import {default as ax} from "axios";
import VueCookies from "vue-cookies";
import store from "@/store";
import {APP_CONFIG} from "@/utils/constants";
import refreshTokeninterceptor from "./utils.js";

let axios = ax.create({
    baseURL: `${process.env.VUE_APP_BLACK_BOX_URL}/api/v1`,
});

axios.interceptors.request.use(
    (config) => {
        let token = VueCookies.get("token");
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
            /*
            This function shouldn't be required at all , BUT is used for now!
            Reason: Initially there was no concept of user/account in saas app.
            so hardcoded userdid /apss was sent(to test atleast), but later on
            jwt based token with our own iAM server & Miniorange was integrated into backend.

            To keep some apis working ex(case list api) which dependes upon some header values,
            use this function.
            */
            config.headers["X-Source"] = `(saas-platform) ${APP_CONFIG.name}/${APP_CONFIG.version}`;
            config.headers["X-User-ID"] = store.getters.getUserAuthDetails.userId;
            config.headers["X-CASE-ID"] = store.getters.getCaseId == null ? "" : store.getters.getCaseId;
        }
        return config;
    },

    (error) => {
        return Promise.reject(error);
    }
);
axios.interceptors.response.use(undefined, refreshTokeninterceptor(axios));
export default axios;

export const CancelToken = ax.CancelToken;
